import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'
import {
  createShouldCostModelRoutes,
  injectionModelingOverviewApiRoutes,
} from '../constants/serviceConstants/injectionMolding.apiRoutes'

export const getInjectionMoldingModelData = createAsyncThunk(
  'injection-molding/get-model-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `${createShouldCostModelRoutes.getModelData}/${payload.modelId}`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getRawMaterialDropdownData = createAsyncThunk(
  'injection-molding/get-raw-material-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      createShouldCostModelRoutes.getRawMaterialDropdownData,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getCountries = createAsyncThunk(
  'injection-molding/get-countries',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', createShouldCostModelRoutes.getCountries, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const saveModel = createAsyncThunk(
  'injection-molding/save-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostModelRoutes.saveModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getKPIsDataAsync = createAsyncThunk(
  'injection-molding/get-kpis-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', injectionModelingOverviewApiRoutes.getKPIs, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getModelsDataAsync = createAsyncThunk(
  'injection-molding/get-models-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', injectionModelingOverviewApiRoutes.getModelsTable, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getUnitsDataAsync = createAsyncThunk(
  'injection-molding/get-units-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostModelRoutes.getUnitsData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getPackgingTypeData = createAsyncThunk(
  'injection-molding/get-packaging-type-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `${createShouldCostModelRoutes.packagingData}`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
